import { render, staticRenderFns } from "./BookingsList.vue?vue&type=template&id=5b0d2bed&scoped=true&"
import script from "./BookingsList.vue?vue&type=script&lang=js&"
export * from "./BookingsList.vue?vue&type=script&lang=js&"
import style0 from "./BookingsList.vue?vue&type=style&index=0&id=5b0d2bed&lang=scss&scoped=true&"
import style1 from "./BookingsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d2bed",
  null
  
)

export default component.exports